// extracted by mini-css-extract-plugin
export default {"wrapper":"HorizontalScroller_wrapper__JkIYa","content":"HorizontalScroller_content__1qUpC","left":"HorizontalScroller_left__MruXJ","right":"HorizontalScroller_right__OfXVs"};